/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Prompt_Tips_Context_DescInputs */

const es_prompt_tips_context_desc = /** @type {(inputs: Prompt_Tips_Context_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mencioná el proveedor, nombres de archivos, carpetas o cualquier pista que tengas. Cuanta más información des, más rápido y preciso será el resultado.`)
};

const en_prompt_tips_context_desc = /** @type {(inputs: Prompt_Tips_Context_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mention the provider, file names, folders, or any clues you have. The more information you give, the faster and more accurate the result.`)
};

/**
* | output |
* | --- |
* | "Mention the provider, file names, folders, or any clues you have. The more information you give, the faster and more accurate the result." |
*
* @param {Prompt_Tips_Context_DescInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const prompt_tips_context_desc = /** @type {((inputs?: Prompt_Tips_Context_DescInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Prompt_Tips_Context_DescInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_prompt_tips_context_desc(inputs)
	return en_prompt_tips_context_desc(inputs)
});
export { prompt_tips_context_desc as "prompt_tips.context_desc" }